import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import Button from '@/components/form/Button';
import { useAuth } from '@/context/AuthContext';

const features = [
  'Create unlimited SNAPs',
  'AI-powered insights',
  'Multiple voting options',
  'Real-time stats',
  'Community features',
  'Private SNAPs'
];

export default function Pricing() {
  const { user } = useAuth();
  const navigateBack = () => window.location.href = user ? '/dashboard' : '/';

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          variant="ghost"
          size="sm"
          icon={<ArrowLeftIcon className="h-4 w-4" />}
          onClick={navigateBack}
          className="mb-12"
        >
          Back to {user ? 'Dashboard' : 'Home'}
        </Button>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-800 mb-6">
            <span className="text-sm font-medium">
              🚀 SnapVote is a startup – everything is 100% free during early access!
            </span>
          </div>
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl lg:text-6xl">
            100% Free. No charge!
          </h1>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            SnapVote is free – no hidden fees, no limitations. Join early and help shape the future of decision-making!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          <div className="px-6 py-12 sm:p-12">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-gray-900">All Core Features Included</h2>
              <p className="mt-2 text-lg text-gray-600">No cost, no limitations</p>
            </div>

            <div className="mt-8">
              <p className="flex items-baseline justify-center">
                <span className="text-5xl font-extrabold text-gray-900">$0</span>
                <span className="ml-1 text-2xl text-gray-500">/month</span>
              </p>
              <p className="mt-2 text-sm text-gray-500 text-center">During beta phase</p>
            </div>

            <ul className="mt-10 space-y-4">
              {features.map((feature) => (
                <li key={feature} className="flex items-start">
                  <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0" />
                  <span className="ml-3 text-gray-600">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <Button
                variant="primary"
                className="w-full text-lg py-4"
                onClick={() => window.location.href = user ? '/create' : '/register'}
              >
                {user ? 'Create Your First SNAP' : 'Get Started Now'}
              </Button>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-16 text-center bg-white rounded-2xl shadow-lg p-8 max-w-3xl mx-auto"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Questions About Our Beta?</h2>
          <p className="text-gray-600 mb-6">
            We’re here to help! Contact us for any questions about our beta program or future pricing plans.
          </p>
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.location.href = 'mailto:info@snapvote.ai'}
          >
            Contact Us
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
